import { render, staticRenderFns } from "./Allegro.vue?vue&type=template&id=12c13b66"
import script from "./Allegro.vue?vue&type=script&lang=js"
export * from "./Allegro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports